import Alpine from "alpinejs";
import mask from "@alpinejs/mask";
import Bugsnag from "@bugsnag/js";
import { datadogRum } from "@datadog/browser-rum";
import "./css/application.scss";
import "@popperjs/core";
import * as bootstrap from "bootstrap";
import "./js/alpine_components/";
import htmx from "htmx.org";

window.bootstrap = bootstrap;
window.htmx = htmx;

Alpine.plugin(mask);
window.Alpine = Alpine;

class MultiplyUtils {
    updateRangeInputTrack(target) {
        const range = target.max - target.min;
        const width = (target.value - target.min) / range;
        const track_width =
            100 - parseFloat(target.style.getPropertyValue("--before-slider-width") || "0");
        target.style.setProperty("--before-track-width", `${track_width * width}%`);
    }

    validateField(form_id, name) {
        let element = document.forms[form_id].elements[name];
        let isValid = element.checkValidity();
        if (!isValid) {
            element.reportValidity();
        }
        return isValid;
    }

    validateRadioField(form_id, name) {
        let radios = document.forms[form_id].elements[name];
        var isValid = false;
        radios.forEach((radio) => {
            if (radio.checked) {
                isValid = true;
            }
        });
        return isValid;
    }
    codeInput(code_length, type, value) {
        return {
            type: type,
            code: value
                ? String(value).split("").slice(0, code_length)
                : Array(code_length).fill(""), // Initialize an array for code storage
            moveToNext(el, index) {
                if (index < code_length - 1) {
                    this.$root
                        .querySelector(".single-code-input-" + (index + 1) + " input")
                        .focus();
                }
            },
            moveNext(el, event, index) {
                this.code[index] = el.value.replace(/[^0-9]/g, "").slice(-1);
                if (!Number.isNaN(Number.parseInt(event.data))) {
                    this.moveToNext(el, index);
                }
            },
            movePrev(el, index) {
                if (index > 0) {
                    this.$root
                        .querySelector(".single-code-input-" + (index - 1) + " input")
                        .focus();
                }
            },
            handlePaste(event) {
                // Handle pasted content by spreading it across inputs
                const paste = (event.clipboardData || window.clipboardData).getData("text");
                const pasteSlice = paste.slice(0, code_length);

                if (Number.isNaN(Number.parseInt(pasteSlice))) {
                    return;
                }

                const pasteArray = pasteSlice.split("");
                pasteArray.forEach((char, index) => (this.code[index] = char));
            },
            deleteChar(el, index) {
                this.code[index] = "";
                this.movePrev(el, index);
            },
        };
    }
    hideFields(fieldNames, toggleOn) {
        for (const name of fieldNames) {
            const el = document.getElementById(`id_${name}`);
            if (toggleOn) {
                el.classList.remove("hidden-form-input");
                el.required = true;
            } else {
                el.classList.add("hidden-form-input");
                el.required = false;
            }
        }
    }
    showToast(text) {
        const toaster = document.getElementById("toaster");
        toaster.appendChild(ToastHtmlDom(text));
    }
    hideModal(id) {
        let modal = bootstrap.Modal.getInstance(document.getElementById(id));
        modal.hide();
    }
    showModal(id) {
        let modal = new bootstrap.Modal(document.getElementById(id));
        modal.show();
    }
    showModalElem(elem) {
        if (!elem) {
            return;
        }
        let modal = new bootstrap.Modal(elem);
        modal.show();
    }
}

const Multiply = {
    Utils: new MultiplyUtils(),
};
window.Multiply = Multiply;

window.addEventListener("load", function () {
    const bugsnagConfigStr = document.querySelector("meta[name=bugsnag-configuration]").content;
    const bugsnagConfig = JSON.parse(bugsnagConfigStr.replaceAll("'", '"'));

    Bugsnag.start(bugsnagConfig);

    this.document.addEventListener(
        "invalid",
        () => {
            this.document.documentElement.style.scrollBehavior = "auto";
            this.setTimeout(() => (this.document.documentElement.style.scrollBehavior = ""), 1000);
        },
        true,
    );

    // when HTMX snapshots the html for history navigation, it uses historyElt.innerHTML
    // This results in an html that does not include any updated input values because the
    // new value is a property of the dom element and not an attribute of its html.
    document.addEventListener("htmx:beforeHistorySave", (event) => {
        const { historyElt } = event.detail;
        historyElt.querySelectorAll("input").forEach((inputElt) => {
            inputElt.setAttribute("value", inputElt.value);

            // Store values from the input in x-init-from-value attribute so they can be restored
            // later if we navigate back to them
            if (inputElt._x_model) {
                inputElt.setAttribute("x-init-from-value", JSON.stringify(inputElt._x_model.get()));
            }
        });
    });

    this.document.addEventListener("htmx:responseError", (event) => {
        const status_code = event.detail.xhr.status;
        if (status_code >= 500) {
            Multiply.Utils.showToast("Unexpected error, please try again later.");
        }
    });

    // This enables our input[type=range] to have a track on the left of the thumb that is
    // different than the track on the right. We do this almost completely in CSS with a before
    // element, but need to update its width to match the input.value
    document.body.addEventListener("input", (event) => {
        if (event.target.type === "range") {
            Multiply.Utils.updateRangeInputTrack(event.target);
            return true;
        }
    });

    // This is adding a dataLayer event whenever htmx pushes a new page into history. The browser
    // cannot detect an HTMX "page change" therefore we have to push a custom event into the dataLayer
    // so that we can pick it up on GTM
    document.body.addEventListener("htmx:pushedIntoHistory", function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "htmxPushedIntoHistory",
            url: event.detail.path,
            timestamp: new Date().getTime(),
        });
    });

    document.body.addEventListener("htmx:historyRestore", () => {
        document.querySelectorAll("[x-from-template]").forEach((e) => e.remove());
    });

    document.querySelectorAll("input[type=range]").forEach((input) => {
        Multiply.Utils.updateRangeInputTrack(input);
    });

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    let sessionExpiringModalDismissedAt = null;
    const sessionExpirationWarningThreshold = 30 * 1000; // show modal 30s before session timeout
    function checkSessionExpiration() {
        const sessionExpiresAtCookie = getCookie("session-expires-at");
        let sessionExpired;
        if (!sessionExpiresAtCookie) {
            sessionExpired = false;
        } else {
            const expireAt = new Date(sessionExpiresAtCookie);
            const now = new Date();

            if (expireAt - now < sessionExpirationWarningThreshold) {
                if (
                    !sessionExpiringModalDismissedAt ||
                    expireAt - sessionExpiringModalDismissedAt > sessionExpirationWarningThreshold
                ) {
                    window.bootstrap.Modal.getOrCreateInstance("#sessionExpiringModal").show();
                }
            } else {
                window.bootstrap.Modal.getOrCreateInstance("#sessionExpiringModal").hide();
            }
            sessionExpired = expireAt - now < 0;
        }
        if (sessionExpired) {
            window.location.reload();
        }
    }
    if (document.querySelector("meta[name=has-session]").content == "True") {
        setInterval(checkSessionExpiration, 1000);
    }
    document.getElementById("sessionExpiringModal").addEventListener("hide.bs.modal", () => {
        sessionExpiringModalDismissedAt = new Date();
    });

    this.document.addEventListener("visibilitychange", () => {
        if (this.document.visibilityState == "visible") {
            checkSessionExpiration();
        }
    });

    const infoModal = document.getElementById("info-modal");
    infoModal.addEventListener("show.bs.modal", (event) => {
        // Button that triggered the modal
        const button = event.relatedTarget;
        const title = button.getAttribute("data-bs-title");
        const content = button.getAttribute("data-bs-content");
        const footer = button.getAttribute("data-bs-footer");
        const modalContent = document.getElementById("info-modal-content");
        const modalHeader = document.getElementById("info-modal-header");
        const modalFooter = document.getElementById("info-modal-footer");
        modalHeader.innerHTML = title;
        modalContent.innerHTML = content;
        if (footer !== null) {
            modalFooter.innerHTML = footer;
        }
    });

    const supportModal = document.getElementById("support-form");
    supportModal.addEventListener("show.bs.modal", (event) => {
        // Button that triggered the modal
        const button = event.relatedTarget;
        const content = button.getAttribute("data-content");
        const modalContent = document.getElementById("support-form-content");
        modalContent.innerHTML = content;
    });

    // Alpine JS observes any DOM mutation and automatically initializes any alpine directives
    // on new elements. HTMX loading content can be a multistep process, which results in some
    // of the new content being into the DOM before and some later. This can result in alpine
    // running on partially loaded content, which can fail.
    // These two events tell alpine to pause processing new dom content until it all has been
    // loaded.
    this.document.addEventListener("htmx:afterSettle", () => {
        Alpine.flushAndStopDeferringMutations();
    });
    this.document.addEventListener("htmx:beforeSwap", () => {
        Alpine.deferMutations();
    });
});

const datadogConfigStr = document.querySelector("meta[name=datadog-configuration]").content;
const datadogConfig = JSON.parse(datadogConfigStr.replaceAll("'", '"'));

datadogRum.init({
    applicationId: datadogConfig.app,
    clientToken: datadogConfig.token,
    site: datadogConfig.site,
    service: datadogConfig.service,
    version: datadogConfig.version,
    env: datadogConfig.env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100, // if not included, the default is 100
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: datadogConfig.unmask_forms ? "allow" : "mask", // Set data masking based on feature flag
});
if (document.querySelector("meta[name=user-id]").content != "None") {
    datadogRum.setUser({
        id: document.querySelector("meta[name=user-id]").content,
        name: document.querySelector("meta[name=user-name]").content,
        email: document.querySelector("meta[name=user-email]").content,
    });
}
datadogRum.startSessionReplayRecording();

let alpineAlreadyStarted = false;
document.addEventListener("alpine:init", () => {
    // restores values stored in a x-init-from-value attribute into the alpine data model
    Alpine.directive("init-from-value", (el, { expression }) => {
        el._x_model.set(JSON.parse(expression));
    });
    alpineAlreadyStarted = true;
});

document.addEventListener("DOMContentLoaded", () => {
    if (!alpineAlreadyStarted) Alpine.start();
});

window.addEventListener("hide.bs.modal", () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
});

function ToastHtmlDom(message) {
    const toastDiv = document.createElement("div");
    toastDiv.className = "toast toast-autohide align-items-center show alert";
    toastDiv.role = "alert";
    toastDiv.ariaLive = "assertive";
    toastDiv.ariaAtomic = true;
    toastDiv.innerHTML = `
    <div>
    ${message}
    </div>
    <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
  `;
    return toastDiv;
}
